/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import { ProductNavBar } from "../../../../../../components/wpl/product-navbar/src";

const JiraSoftwareNavPaidLpJswPm = () => {
    const intl = useIntl();
    return (
        <ProductNavBar
            productHref={useLocalizedHref("/software/jira")}
            productName="jirasoftware"
            freeHref={useLocalizedHref("/software/jira/free")}
            ariaLabel={intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            })}
            dataProductKey="jiraSoftware"
            showFreeHrefButton={false}
        />
    );
};

JiraSoftwareNavPaidLpJswPm.displayName = "JiraSoftwareNav";

export default JiraSoftwareNavPaidLpJswPm;
